import { Column } from "react-table";
import { TableCustomHeader } from "../../component/table/components/TableCustomHeader";
import { TableCustomCell } from "../../component/table/components/TableCustomCell";

export const COLUMNS: ReadonlyArray<Column<any>> = [
  {
    Header: (props) => (
      <TableCustomHeader<any>
        tableProps={props}
        title="STT"
        className="text-center text-light spaces W-40"
      />
    ),
    id: "stt",
    Cell: ({ ...props }) => (
      <TableCustomCell
        className="text-center "
        data={props.data[props.row.index].stt}
      />
    ),
  },
  {
    Header: (props) => (
      <TableCustomHeader<any>
        tableProps={props}
        title={"Tên đơn vị cung cấp dịch vụ"}
        className="text-center text-white align-middle bg-pri min-w-100px"
      />
    ),
    id: "clinicName",
    Cell: ({ ...props }) => (
      <TableCustomCell
        className="s-2"
        data={props.data[props.row.index].orgProvideName}
      />
    ),
  },
  {
    Header: (props) => (
      <TableCustomHeader<any>
        tableProps={props}
        title={"Địa chỉ"}
        className=" text-white text-center align-middle bg-pri min-w-200px"
      />
    ),
    id: "address",
    Cell: ({ ...props }) => (
      <TableCustomCell
        className="s-2"
        data={props.data[props.row.index].addressFull}
      />
    ),
  },
  // {
  //   Header: (props) => (
  //     <TableCustomHeader<any>
  //       tableProps={props}
  //       title={"Khoảng cách"}
  //       className=" text-center text-white align-middle bg-pri spaces W-100"
  //     />
  //   ),
  //   id: "distance",
  //   Cell: ({ ...props }) => (
  //     <TableCustomCell
  //       data={props.data[props.row.index]?.distance}
  //       className="text-center"
  //     />
  //   ),
  // },
];
